import React, {useEffect, useState} from 'react'
import {BrowserRouter as Router, Route, Switch,} from 'react-router-dom'
import publicRouter from "../router/public.router";
import PublicHeader from "../components/header/PublicHeader";
import NotificationProvider from "../providers/notifications/NotificationProvider";
import HomeBanner from "../components/Image/HomeBanner";
import {initGA} from "../services/AnalyticsService";

const App = () => {
    const [showBanner, setShowBanner] = useState(false)

    const handleLocationChange = () => {
        const {innerWidth} = window

        if ((window.location.pathname === "/" || window.location.pathname === "/accueil") && !showBanner && innerWidth > 768) {
            setShowBanner(true)
        } else if (showBanner && innerWidth > 768) {
            setShowBanner(false)
        } else {
            setShowBanner(false)
        }
    }

    useEffect(() => {
        handleLocationChange()
        window.addEventListener("location change", handleLocationChange)
        window.addEventListener("resize", handleLocationChange)

        return () => {
            window.removeEventListener("location change", handleLocationChange)
            window.removeEventListener("resize", handleLocationChange)
        }
    }, [])

    useEffect(() => {
        if (process.env.NODE_ENV !== 'development') {
            initGA()
        }
    }, []);


    return (
        <NotificationProvider>
            <Router>
                {showBanner && <HomeBanner />}

                <PublicHeader />

                <Switch>
                    {
                        publicRouter.map((route, index) => (
                            <Route
                                key={index}
                                path={route.path}
                                exact={route.exact || false}
                            >
                                {route.component()}
                            </Route>
                        ))
                    }
                </Switch>
            </Router>
        </NotificationProvider>
    )
}

export default App
